module.exports = __webpack_public_path__ + "img/white-logo.a0de0360.png";